// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import PageProps from "@insite/client-framework/Types/PageProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import BlogTile, { BlogTilePresentationProps } from "@store/Library/Components/Toolkit/Blog/BlogTile";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface BlogTileListPresentationProps extends ExpandStyles<BlogTileListStyles> {}

export interface BlogTileListProps extends BlogTileListPresentationProps {
    articles: PageProps[];
    articlesLinks: SafeDictionary<PageLinkModel>;
}

export interface BlogTileListStyles {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    blogTile?: BlogTilePresentationProps;
}

export const blogTileListStyles: BlogTileListStyles = {
    gridContainer: {
        offsetProps: { as: "ul" },
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([26]))}
        `,
    },
    gridItem: {
        as: "li",
        width: [12, 6, 4, 4, 4],
    },
};

const BlogTileList: FC<BlogTileListProps> = ({ articles, articlesLinks, extendedStyles, overridedStyles }) => {
    const styles = useExpandProps(blogTileListStyles, extendedStyles, overridedStyles);

    if (!articles.length) {
        return null;
    }

    return (
        <GridContainer {...styles.gridContainer}>
            {articles.map((article: PageProps) => {
                const {
                    id,
                    fields: { publishDate, tileImage, title },
                    nodeId,
                    parentId,
                } = article;

                if (typeof articlesLinks[nodeId]?.url === "undefined") {
                    return null;
                }

                return (
                    <GridItem key={id} {...styles.gridItem}>
                        <BlogTile
                            {...styles.blogTile}
                            category={articlesLinks[parentId]?.title}
                            imagePath={tileImage}
                            linkHref={articlesLinks[nodeId]?.url}
                            publishDate={publishDate}
                            title={title}
                        />
                    </GridItem>
                );
            })}
        </GridContainer>
    );
};

export default BlogTileList;
